import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PastVisitDrawerShell from './PastVisitDrawerShell';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/** Doctor past-visit drawer — loads /api/consultations/:id. */
export function PastVisitDrawer({ consultationId, onClose, title }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!consultationId) return undefined;
    let cancelled = false;
    setLoading(true);
    setError(null);
    axios.get(`${API_URL}/api/consultations/${consultationId}`, { withCredentials: true })
      .then(({ data: d }) => { if (!cancelled) { setData(d); setLoading(false); } })
      .catch((e) => {
        if (!cancelled) {
          setError(e?.response?.data?.detail || 'Failed to load visit');
          setLoading(false);
        }
      });
    return () => { cancelled = true; };
  }, [consultationId]);

  return (
    <PastVisitDrawerShell
      title={title}
      onClose={onClose}
      data={data}
      loading={loading}
      error={error}
      testId="past-visit-drawer"
    />
  );
}
